$(".testi-slider").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 2000,
  centerMode: true,
  centerPadding: "60px",
  arrows: true,
  prevArrow: '<button type="button" class="slick-prev custom-arrow"><img src="https://cdn.shopify.com/s/files/1/0514/7849/5412/files/arrow-icon02.png?v=1750141693" alt="Prev" /></button>',
  nextArrow: '<button type="button" class="slick-next custom-arrow"><img src="https://cdn.shopify.com/s/files/1/0514/7849/5412/files/arrow-icon.png?v=1750141698" alt="Next" /></button>',
  dots: false,

  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        centerMode: true,
        centerPadding: "40px"
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        centerMode: true,
        centerPadding: "80px"
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        centerPadding: "30px"
      }
    }
  ]
});


// comparison-imgbox sec

document.addEventListener("DOMContentLoaded", function () {
  const imageComparisonSliders = document.querySelectorAll('[data-component="image-comparison-slider"]');

  imageComparisonSliders.forEach((slider) => {
    function setSliderState(e, element) {
      const sliderRange = element.querySelector('[data-image-comparison-range]');
      if (e.type === 'input') {
        sliderRange.classList.add('image-comparison__range--active');
      } else {
        sliderRange.classList.remove('image-comparison__range--active');
        element.removeEventListener('mousemove', moveSliderThumb);
      }
    }

    function moveSliderThumb(e) {
      const sliderRange = slider.querySelector('[data-image-comparison-range]');
      const thumb = slider.querySelector('[data-image-comparison-thumb]');

      if (!sliderRange || !thumb) return;

      let position = e.clientY - sliderRange.getBoundingClientRect().top - 20;
      position = Math.max(-20, Math.min(position, sliderRange.offsetHeight - 20));

      thumb.style.top = `${position}px`;
    }

    function moveSliderRange(e, element) {
      const value = e.target.value;
      const sliderHandle = element.querySelector('[data-image-comparison-slider]');
      const imageWrapperOverlay = element.querySelector('[data-image-comparison-overlay]');

      if (!sliderHandle || !imageWrapperOverlay) return;

      sliderHandle.style.left = `${value}%`;
      imageWrapperOverlay.style.width = `${value}%`;

      element.addEventListener('mousemove', moveSliderThumb);
      setSliderState(e, element);
    }

    function init(element) {
      const sliderRange = element.querySelector('[data-image-comparison-range]');

      if (!sliderRange) return;

      if (!("ontouchstart" in window)) {
        sliderRange.addEventListener('mouseup', (e) => setSliderState(e, element));
        sliderRange.addEventListener('mousedown', (e) => {
          moveSliderThumb(e);
          element.addEventListener('mousemove', moveSliderThumb);
        });

        document.addEventListener('mouseup', () => {
          element.removeEventListener('mousemove', moveSliderThumb);
        });
      }

      sliderRange.addEventListener('input', (e) => moveSliderRange(e, element));
      sliderRange.addEventListener('change', (e) => moveSliderRange(e, element));
    }

    init(slider);
  });
});

// rebuy app bundle warp 
const waitAndWrap = setInterval(() => {
    const imageEls = document.querySelectorAll(".rebuy-bundle__image");
    const productEls = document.querySelectorAll(".rebuy-product-block");

    if (imageEls.length === 0 || productEls.length === 0) return;

    let wrapped = 0;

    imageEls.forEach((image) => {
      const productIdClass = Array.from(image.classList).find(c => c.startsWith("product-id-"));
      if (!productIdClass) return;

      const matchingProduct = Array.from(productEls).find(prod => prod.classList.contains(productIdClass));

      // Prevent double wrapping
      if (matchingProduct && !image.closest(".image-block") && !matchingProduct.closest(".image-block")) {
        const wrapper = document.createElement("div");
        wrapper.className = "image-block";
        image.parentNode.insertBefore(wrapper, image);
        wrapper.appendChild(image);
        wrapper.appendChild(matchingProduct);
        wrapped++;
      }
    });

    if (wrapped > 0) {
      console.log(`✅ Wrapped ${wrapped} image-product pairs.`);
      clearInterval(waitAndWrap);
    }
  }, 500);


const imageMap = new Map();

function setupCheckboxImageToggle() {
  document.querySelectorAll('.rebuy-product-block').forEach(productBlock => {
    const checkbox = productBlock.querySelector('input.rebuy-checkbox');
    const productIdClass = [...productBlock.classList].find(cls => cls.startsWith('product-id-'));

    if (!checkbox || !productIdClass) return;

    const imageBlock = productBlock.closest('.image-block');
    if (!imageBlock) return;

    const imageEl = imageBlock.querySelector(`.rebuy-bundle__image.${productIdClass}`);
    if (!imageEl) return;

    // Store the image element for later re-insertion
    imageMap.set(checkbox, imageEl);

    checkbox.addEventListener('change', () => {
      const storedImage = imageMap.get(checkbox);

      if (checkbox.checked) {
        // Re-insert the image if it's not in the DOM
        if (storedImage && !imageBlock.contains(storedImage)) {
          imageBlock.appendChild(storedImage);
        }
      } else {
        // Remove image from DOM but keep reference
        if (storedImage && imageBlock.contains(storedImage)) {
          storedImage.remove();
        }
      }
    });
  });
}

// Wait for DOM + rebuy widgets to load
const checkInterval = setInterval(() => {
  const checkboxes = document.querySelectorAll('.rebuy-product-block input.rebuy-checkbox');
  const images = document.querySelectorAll('.rebuy-bundle__image');
  const wrappers = document.querySelectorAll('.image-block');

  if (checkboxes.length && images.length && wrappers.length) {
    clearInterval(checkInterval);
    setupCheckboxImageToggle();
  }
}, 300);


// add and remove
$(document).ready(function(){
  $(".cust-collection-stepibox .read-more-btn").click(function () {
    $(this).toggleClass("active");
  });
});



// Disable auto-submit without breaking theme event listeners; enable Apply button
document.addEventListener('DOMContentLoaded', function(){
  const form = document.querySelector('[data-collection-filters-form]');
  if (!form) return;

  // Stop the theme's auto-submit for filters, but allow sort radios to auto-apply
  let allowNextFormInputSubmit = false;
  const blockAutoSubmit = function(e){
    if (!e) return;
    const t = e.target;
    // Permit the next form input event triggered by sort change
    if (allowNextFormInputSubmit) {
      allowNextFormInputSubmit = false;
      return;
    }
    // Allow direct input events from sort radios (rare, but safe)
    if (t && (t.matches && t.matches('[data-input-sort]'))) {
      return;
    }
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (e.stopPropagation) e.stopPropagation();
  };
  // Capture phase so we intercept before theme.js listeners
  form.addEventListener('input', blockAutoSubmit, true);
  form.addEventListener('theme:filter:range-update', blockAutoSubmit, true);

  // Apply button explicitly submits non-sort filter changes
  document.addEventListener('click', function(e){
    const applyBtn = e.target.closest('[data-apply-filters]');
    if (!applyBtn) return;
    form.submit();
  });

  // Auto-close sort dropdown after a selection (works across re-renders)
  // Capture-phase handler sets the allow flag BEFORE theme's target listener dispatches form input
  document.addEventListener('change', function(e){
    const target = e.target;
    if (!target || !(target.matches && target.matches('[data-input-sort]'))) return;
    allowNextFormInputSubmit = true;
  }, true);

  // Bubble-phase handler just closes the dropdown for UX
  document.addEventListener('change', function(e){
    const target = e.target;
    if (!target || !(target.matches && target.matches('[data-input-sort]'))) return;
    const sortWrapper = document.querySelector('[data-collection-sort-options]');
    if (sortWrapper && sortWrapper.classList.contains('collection__sort__option-wrapper--visible')){
      sortWrapper.classList.remove('collection__sort__option-wrapper--visible');
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Wait until jQuery is available (Shopify themes usually have jQuery)
  if (typeof jQuery !== "undefined") {
    jQuery(function ($) {
      $('.early-bird .product-grid-item__quick-buy.aos-init.aos-animate')
        .insertAfter('.early-bird .product-grid-item__info.product-grid-item__info--inline.aos-init.aos-animate');
    });
  } else {
    console.error("jQuery not found!");
  }
});
